export function designationsList({ designations }) {
  return designations.designationsList.data;
}
